import xlsx from 'xlsx';

export const exportToExcel = (data, columns, name) => {
    if(name.length >= 31) name = name.slice(0,31);
    const book = xlsx.utils.book_new();
    const sheet = xlsx.utils.aoa_to_sheet([ columns, ...data ]);
    xlsx.utils.book_append_sheet(book, sheet, name);
    xlsx.writeFile(book, name + '.xlsx');
};